// extracted by mini-css-extract-plugin
module.exports = {"content":"Paragraph_content__Utjwn","title":"Paragraph_title__qU8n3"};